<p-toast position="top-center no-print"></p-toast>
  <div class="w-full screenHeight flex justify-content-center align-content-center" [ngClass]="'bg-agsquare'">
    <div class="screenHeight flex justify-content-center align-content-center">
      <div class="mt-0 form-signin mb-4 screenHeight flex justify-content-center align-content-center">
        <div class="text-center mb-4">
          <div class="flex flex-wrap h-full justify-content-center align-content-center " >
            <div class="w-full h-full flex flex-wrap justify-content-center align-content-center pr-0 pl-0">
              <div class="text-900 text-3xl font-bold text-center">
                Conferma credenziali
              </div>
              <div class="row-6 btnWidth flex flex-wrap align-content-center justify-content-center pr-0 pl-0">
                <label class="text-900 font-medium mb-2 mt-4 py-1">
                  Inserisci la tua Email
                </label>
                <input  id="username"
                        placeholder="email@email.com"
                        type="text"
                        pInputText
                        class="text-center w-full "
                        [disabled]="false"
                        autocomplete="new-password"
                        [(ngModel)]="loginRequestModel.username"d>
              </div>
              <div class="w-full flex justify-content-center p-0">
                <div class="w-full justify-content-center block py-3 mx-2">
                  <button pButton pRipple label="Invia" icon="pi pi-user" class="mt-2 btnWidth p-button-rounded" (click)="confirmEmail(loginRequestModel.username)"></button>
                </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>


<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
